/*
    Page navigation.
*/
import { setToClass } from './code'

export function showNavigationForMobile(event) {
    event.target.parentElement.classList.toggle('active')
    setToClass('menu-open', function(element) { element.classList.toggle('active') })
}
